<template>
  <main class="main recover-password max-width amateur">
    <article>
      <div>
        <h1 class="title-medium">Recupero password</h1>
        <p class="title-medium light">Inserisci la nuova password per il tuo account sul sito di Edizioni Caramba.</p>

        <!-- data-request="resetPassword::onRestorePassword" data-request-update="'site/resetpassword/checkmail': '#partialUserResetForm'" -->
        <form @submit.prevent="onSubmit">
          <div class="form-group">
            <label for="userRestorePassword">Password</label>
            <input name="password" type="password" id="userRestorePassword" v-model="password" placeholder="Inserisci la tua nuova password" />
            <!-- <input name="email" type="email" class="form-control" placeholder="Scrivi la tua email" ref="email"> -->
          </div>

          <button class="btn btn-default button-anim">CONFERMA PASSWORD</button>
        </form>

        <no-interaction-overlay 
          :isActive = "state && state == 'req-sent'"
          bgColor="azure"
          message="Stiamo salvando la nuova password. Per favore, attendi.."
        ></no-interaction-overlay>
        
        <snackbar 
          :states="states" 
          :state="state"
          :showSnackbar="showSnackbar"
          @close="showSnackbar = false"
        ></snackbar>
      </div>
    </article>
  </main>
</template>

<script>
import axios from 'axios/dist/axios';
import NoInteractionOverlay from './NoInteractionOverlay.vue';
import Snackbar from './Snackbar.vue';

export default {
  data() {
    return {
      states: [
        {name: 'failure', message: 'Spiacenti! Non è stato possibile resettare la password. Per favore, riprova!', bgColor: 'light_purple'}
      ],
      state: undefined,
      showSnackbar: false,

      password: '',
      code: undefined
    }
  },

  mounted() {
    this.code = this.getParameterByName('code');
    //console.log(this.code);
    document.title = 'Caramba - Recupero Password';
  },

  methods: {
    onSubmit: function() {
      this.state = 'req-sent';
      this.updatePassword();
    },

    updatePassword: function() {
      const data = {code: this.code, password: this.password};
      axios.post('/api/v1/user/reset_password', data)
        .then(resp => {
          this.$router.push({path: 'login', query: {state: 'passwordRestore:success'}});
        })
        .catch(err => {
          this.state = 'failure';
          this.showSnackbar = true;
        });
    },

    getParameterByName: function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
      let results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
  },

  components: {
    'no-interaction-overlay': NoInteractionOverlay,
    'snackbar': Snackbar
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/vue/components/ResetPassword.vue